module.exports = __webpack_public_path__ + "static/other-workshop-1f822e89010a96628c74ed94266ea7e4.jpg";